import ActiveRecordResource from './ActiveRecordResource';
import {FanBoxMessagesImage, FanBoxMessagesImageDTO} from './fanboxMessagesImage';
import {AwsVideo} from './videoAws'
import {UserDTO} from './manager';
import config from 'config';
import { VideoModel } from "../api/video"

export const FAN_BOX_MESSAGES_TYPE_EVENT = 'event';
export const FAN_BOX_MESSAGES_TYPE_PROMO = 'promo';
export const FAN_BOX_MESSAGES_TYPE_VIP_PROMO = 'vip-promo';

export interface FanBoxMessageDTO {
  id: string;
  club_id: string;
  title: string;
  content: string;
  short_content: string;
  vip_only?: boolean;
  message_type: string;
  image_url: FanBoxMessagesImageDTO;
  created_by: UserDTO;
  created_at: number;
  publish_at: number;
  published: boolean;
  video_url?: string;
}

class FanBoxMessages extends ActiveRecordResource {
  static path = `${config.backOfficeBasePath}/fan_box/messages`;

  static messageTypes = [
    {
      value: FAN_BOX_MESSAGES_TYPE_EVENT,
      label: 'Event'
    },
    {
      value: FAN_BOX_MESSAGES_TYPE_PROMO,
      label: 'Promo'
    }
  ];

  static validateConstraints = {

    title: {
      presence: true
    },

    content: {
      presenceContent: {message: '^Description is missing'}
    },

    message_type: {
      presence: true,
      inclusion: FanBoxMessages.messageTypes.map(item => item.value)
    }

  };

  static mapRecords(data: FanBoxMessageDTO[]) {
    return data.map((item) => this.parseData(item));
  }

  protected _alreadyPublished: boolean;
  title: string = '';
  content: string = '';
  short_content: string = '';
  club_id: string;
  vip: boolean = false;
  message_type: string = FAN_BOX_MESSAGES_TYPE_PROMO;
  published: boolean = false;
  recipient: string = 'all';
  image: FanBoxMessagesImage;
  createDate: Date;
  publishDate: Date;
  video: AwsVideo;

  static parseData(data: FanBoxMessageDTO) {
    let res = new FanBoxMessages({});

    return Object.assign(res, res._parseData(data));
  }

  _parseData(data: FanBoxMessageDTO) {
    return {
      id: data.id,
      title: data.title,
      club_id: data.club_id,
      published: data.published,
      content: data.content,
      short_content: data.short_content,
      image: data.image_url
        ? new FanBoxMessagesImage(Object.assign(new FanBoxMessagesImageDTO(), data.image_url))
        : null,
      video: data.video_url 
        ? new AwsVideo({ isSaved: true, url: data.video_url }) 
        : null,
      createDate: new Date(data.created_at),
      createdBy: data.created_by,
      publishDate: data.publish_at ? new Date(data.publish_at) : null
    };
  }

  _getModel() {
    return FanBoxMessages;
  }

  async save(data: any) {
    const vip = data.vip;
    let needToPublish = !this.isPublished() && data.published;
    let video = data.video instanceof VideoModel ? await AwsVideo.uploadVideo(data.video) : undefined

    await super.save({ ...data, video });

    return needToPublish
      ? await this.publish(vip)
      : this;
  }

  async publish(vip?: boolean) {
    let data = await this._networkLayer.patchJSON(this._getPublishLink(), {
      vip_only: vip
    });
    this._extendData(data);

    return this;
  }

  isPublished() {
    return this._alreadyPublished;
  }

  _extendData(data): any {
    this._alreadyPublished = data.published;
    return super._extendData(data);
  }


  _getPublishLink() {
    return this._prepareUrl(this.id) + '/publish';
  }

  prepareForSave(values: any): FanBoxMessageDTO {
    let { content, short_content, title, image, club_id, vip, video } = values;
    
    let data: any = {
      content,
      short_content,
      message_type: FAN_BOX_MESSAGES_TYPE_PROMO,
      title,
      club_id,
      video_url: video ? video.url : undefined,
    };

    if (image && !image.isSaved) {
      data.file = image.file;
    } else if(image === null && this.image !== null) {
      data.delete_image = true;
    }

    return data;
  }

  async createPromoMessage(data) {
    try {
      return await this._networkLayer.postJson(
        this._prepareUrl() + '/promo',
        data
      );
    }
    catch (error) {
      /* eslint no-console: 0*/
      console.error(error);
      throw(error);
    }
  }
}

export default FanBoxMessages;



// WEBPACK FOOTER //
// ./src/api/fanboxMessages.ts